const env = "Production"

export let API;

if (env === "Development") {
    API = "http://localhost:8000/api";
} else {
    API = "https://api.dtccarlifestyle.com/api";
}
